import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const SEARCH_FAMILY_GROUPS_QUERY = gql`
  query SearchFamilyGroups(
    $searchTerm: String!
    $includeNonFamilyGroups: Boolean!
    $take: Float!
  ) {
    searchFamilyGroups(
      searchTerm: $searchTerm
      take: $take
      includeNonFamilyGroups: $includeNonFamilyGroups
    ) {
      cloudId
      name
    }
  }
` as import('../../__generated__/ts-gql/SearchFamilyGroups').type;

export type SearchFamilyGroupsQueryVariables = OperationVariables<
  typeof SEARCH_FAMILY_GROUPS_QUERY
>;
export type SearchFamilyGroupsQueryResult = OperationData<
  typeof SEARCH_FAMILY_GROUPS_QUERY
>;

export type SearchFamilyGroupsResult = NonNullable<
  SearchFamilyGroupsQueryResult['searchFamilyGroups']
>[number];

export const useSearchFamilyGroups = (
  options: QueryHookOptions<
    SearchFamilyGroupsQueryResult,
    SearchFamilyGroupsQueryVariables
  >
) => {
  const variables = options.variables as SearchFamilyGroupsQueryVariables;

  const res = useQuery(SEARCH_FAMILY_GROUPS_QUERY, {
    context: { service: 'clients' },
    variables,
    ...options,
  });

  return React.useMemo(
    () => ({ ...res, data: res.data?.searchFamilyGroups }),
    [res]
  );
};
